import type { ItineraryCostItem } from "./itineraryCostUtils";
import { calculateItemTotalCost } from "./itineraryCostUtils";

export type Currency = "ZAR" | "USD" | "EUR";

export interface ExchangeRates {
  USD_to_ZAR?: number;
  EUR_to_ZAR?: number;
}

export function toZAR(amount: number, currency: string | null | undefined, rates: ExchangeRates | undefined): number {
  if (!amount) return 0;
  const c = (currency || "ZAR").toUpperCase();
  if (c === "ZAR") return amount;
  if (c === "USD") return amount * (rates?.USD_to_ZAR ?? 18.5);
  if (c === "EUR") return amount * (rates?.EUR_to_ZAR ?? 20);
  return amount;
}

export function sumActualsForItem(
  entries: Array<{ amount: number; currency: string }>,
  targetCurrency: string,
  rates: ExchangeRates | undefined
): number {
  return entries.reduce((sum, e) => {
    if ((e.currency || "ZAR").toUpperCase() === targetCurrency.toUpperCase()) {
      return sum + Number(e.amount || 0);
    }
    // convert via ZAR pivot
    const zar = toZAR(Number(e.amount || 0), e.currency, rates);
    if (targetCurrency.toUpperCase() === "ZAR") return sum + zar;
    if (targetCurrency.toUpperCase() === "USD") return sum + zar / (rates?.USD_to_ZAR ?? 18.5);
    if (targetCurrency.toUpperCase() === "EUR") return sum + zar / (rates?.EUR_to_ZAR ?? 20);
    return sum + zar;
  }, 0);
}

export function budgetForItem(item: ItineraryCostItem): number {
  return calculateItemTotalCost(item);
}

export function formatVariancePct(budget: number, actual: number): string {
  if (!budget) return actual ? "—" : "0%";
  const pct = ((budget - actual) / budget) * 100;
  const sign = pct >= 0 ? "+" : "";
  return `${sign}${pct.toFixed(1)}%`;
}